import React from 'react';
import { Input } from '../../../../../base/components/Forms/Input';
import { Icon } from '../../../../../base/components/Icon';
import { useAppDispatch, useAppSelector } from '../../../../../base/hooks';
import { __t } from '../../../../../base/utils/t';
import { responsesActions } from '../../redux/slices/responsesSlice';

import './styles.scss';

export const SearchInput = () => {
    const dispatch = useAppDispatch();
    const workerSearch = useAppSelector((state) => state.employerResponses.workerSearch);

    const onInputChange = (value: string) => {
        dispatch(responsesActions.setWorkerSearch(value));
    };

    const clearSearchHandler = () => dispatch(responsesActions.setWorkerSearch(''));

    return (
        <div className='responses-filter-search__search responses-search'>
            <Icon icon='magnifying-glass-regular' color='info' className='responses-search__icon' />
            <Input
                value={workerSearch}
                placeholder={__t('Пошук по ID або імені робітника')}
                onChange={onInputChange}
                className='responses-search__input'
            />
            {workerSearch && (
                <div className='responses-search__close-icon-wrap'>
                    <div onClick={clearSearchHandler}>
                        <Icon icon='xmark-regular' className='responses-search__close-icon' color='info' />
                    </div>
                </div>
            )}
        </div>
    );
};
